<script setup>
import { computed } from "vue";
import { useI18n } from "vue-i18n";

import { Link, usePage } from "@inertiajs/vue3";

const locale = computed(() => usePage().props.locale);

// Layout
import PublicLayout from "@/Layouts/PublicLayout.vue";
import AboutFirst from "@/Components/AboutFirst.vue";
import AboutSecond from "@/Components/AboutSecond.vue";
import AboutThird from "@/Components/AboutThird.vue";
import AboutFourth from "@/Components/AboutFourth.vue";
import AboutFifth from "@/Components/AboutFifth.vue";
import AboutSix from "@/Components/AboutSix.vue";
import AboutSeven from "@/Components/AboutSeven.vue";

const { t } = useI18n();

const props = defineProps({
  page: Object,
  jobOffers: Object,
  blogArticles: {
    type: Array,
    required: true
  }
});
</script>

<template>
  <PublicLayout title="Zorgblik">
    <AboutFirst />
    <AboutSecond />
    <AboutThird />
    <AboutFourth />
    <AboutFifth />
    <AboutSix />
    <AboutSeven />
  </PublicLayout>
</template>
